import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

const pathMap = {
	[Locale.cs]: "/objednavky" as const,
	[Locale.en]: "/orders" as const,
} satisfies LocalizedString;

export function getOrderListingPath(tenant: Tenant): string {
	return getPathInLocale(tenant.locale, pathMap);
}
